function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M21.15,19.11c0.1-0.35,0.21-0.69,0.32-1.03c-0.13,0.39-0.26,0.78-0.4,1.17C21.1,19.2,21.13,19.16,21.15,19.11z "
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M21.71,11.76c0,0-0.01,0.04-0.02,0.12c0-0.01,0.01-0.03,0.02-0.06C21.71,11.79,21.71,11.77,21.71,11.76z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M21.71,11.76c0,0-0.01,0.04-0.02,0.12c0-0.01,0.01-0.03,0.02-0.06C21.71,11.79,21.71,11.77,21.71,11.76z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M22.97,29.62c-0.34-3.1,0.58-6.21,1.78-9.1c1.2-2.89,2.68-5.66,3.55-8.66c0.17-0.57,0.31-1.19,0.12-1.76 c-0.01-0.04-0.03-0.09-0.05-0.13c-0.24-0.5-0.83-0.87-1.34-0.66c-0.33,0.14-0.53,0.47-0.71,0.78c-1.73,3.01-3.45,6.02-5.18,9.02 c-3.89,12.88-6.9,30.33-6.9,30.33l9.32-15.92C23.57,33.51,23.12,30.92,22.97,29.62z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M13.92,15.87c-0.04,0.12-0.07,0.24-0.11,0.36c0.1-4.54,0.2-9.08,0.3-13.61c0.02-1.06-0.28-2.49-1.34-2.52 c-0.91-0.02-1.39,1.07-1.57,1.97c-0.69,3.51-0.61,7.11-1.07,10.66s-1.54,7.18-4.08,9.69c-0.13,0.13-0.29,0.27-0.48,0.26 c-0.36-0.01-0.47-0.49-0.48-0.85c-0.05-1.69-0.2-3.43-0.99-4.92c-0.63-1.18-1.81-2.27-3.17-2.47c-1.92-0.28-0.14,2.65,0.08,3.52 c0.41,1.6,0.2,3.29,0.43,4.93c0.29,2.1,1.28,4.03,1.98,6.03c0.66,1.89,1.9,5.18,1.9,5.18s4.85,8.4,8.93,15.34 c0,0,0.01-0.14,0.02-0.4l-0.43-32.8L13.92,15.87z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M17.8,17.52c1.05-4.2,2.09-8.4,3.14-12.6c0.26-1.02,0.51-2.07,0.42-3.12c-0.05-0.61-0.27-1.27-0.82-1.53 c-0.55-0.26-1.24,0-1.64,0.46c-0.41,0.45-0.6,1.06-0.78,1.64c-1.4,4.5-2.79,9-4.19,13.5l-0.09,0.36l0.43,32.8 c0.13-2.8,1.02-19.69,3.8-32.18C17.98,17.08,17.89,17.3,17.8,17.52z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M23.59,3.9c0.09-0.07,0.18-0.14,0.26-0.2C23.76,3.76,23.67,3.82,23.59,3.9z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M21.71,11.76c0,0-0.01,0.04-0.02,0.12c0-0.01,0.01-0.03,0.02-0.06C21.71,11.79,21.71,11.77,21.71,11.76z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M21.07,19.25c0.13-0.39,0.26-0.78,0.4-1.17c0.48-1.55,0.98-3.03,1.49-4.39c0.81-2.37,1.61-4.75,2.42-7.12 c0.19-0.56,0.38-1.14,0.33-1.72c-0.06-0.59-0.43-1.19-1-1.31c-0.31-0.07-0.59,0-0.85,0.16c-0.09,0.07-0.17,0.13-0.26,0.2 c-0.39,0.36-0.7,0.93-0.9,1.44c-1.54,3.84-3.08,7.68-4.62,11.52c-3.04,13.65-3.82,32.58-3.82,32.58s3.01-17.44,6.9-30.33 C21.13,19.16,21.1,19.2,21.07,19.25z M21.71,11.76c0,0.02,0,0.04-0.01,0.06c-0.01,0.03-0.01,0.05-0.02,0.06 C21.7,11.8,21.71,11.76,21.71,11.76z"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  className: "st9",
  cx: 13.79,
  cy: 27.46,
  r: 6.84
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.57 49.53",
    style: {
      enableBackground: "new 0 0 28.57 49.53"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.0765,
    y1: 18.4722,
    x2: 21.4631,
    y2: 18.8588
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDA13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    style: {
      stopColor: "#F18009"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4070F"
    }
  })), _ref3, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -20.9947,
    y1: -30.8774,
    x2: 35.1482,
    y2: 25.2655
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDA13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    style: {
      stopColor: "#F18009"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4070F"
    }
  })), _ref4, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.6742,
    y1: 11.7915,
    x2: 21.7207,
    y2: 11.8379
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDA13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    style: {
      stopColor: "#F18009"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4070F"
    }
  })), _ref5, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.9578,
    y1: 22.2926,
    x2: 27.6746,
    y2: 36.0094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDA13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    style: {
      stopColor: "#F18009"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4070F"
    }
  })), _ref6, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.665,
    y1: 11.7188,
    x2: 52.0346,
    y2: 63.0884
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDA13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    style: {
      stopColor: "#F18009"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4070F"
    }
  })), _ref7, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.2075,
    y1: 13.4104,
    x2: 28.0475,
    y2: 35.2503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDA13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    style: {
      stopColor: "#F18009"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4070F"
    }
  })), _ref8), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.9709,
    y1: 1.054,
    x2: 24.2733,
    y2: 4.3565
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDA13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    style: {
      stopColor: "#F18009"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4070F"
    }
  })), _ref9, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.6742,
    y1: 11.7915,
    x2: 21.7207,
    y2: 11.8379
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDA13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    style: {
      stopColor: "#F18009"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4070F"
    }
  })), _ref10, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.2927,
    y1: 17.1903,
    x2: 28.3932,
    y2: 35.2908
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDA13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    style: {
      stopColor: "#F18009"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4070F"
    }
  })), _ref11)), _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6359d0da.svg";
export { ForwardRef as ReactComponent };